import React, {Component} from 'react';
import * as R from 'ramda';
import {Modal} from 'react-bootstrap';
import {CampaignGuidelines} from 'js/components/campaign_guidelines';
import {Provider} from 'react-redux';
import {handleActions} from 'redux-actions';
import {createStore} from 'redux';
import Loader from 'react-loader';
import hydrateAdminSession from 'js/admin_session';

const store = createStore(handleActions({}), {
    user: {},
    bypassInviteQualification: true
});

export default class InviteModal extends Component {
    constructor() {
        super();

        this.state = {
            hydratedSession: false
        };
    }
    componentDidMount() {
        hydrateAdminSession().then(() => {
            this.setState({hydratedSession: true});
        });
    }

    render() {
        const {show, onHide, ...p} = this.props;

        /**
         * When displaying Campaign Guidelines without a redux store we need to just ignore the smart questions for now because
         * they are heavily integrated with the existing Creator application
         */
        const propsToUse = R.omit(['smart_questions'], this.props);
        propsToUse.smart_question_answer_result = true;

        return (
            <Provider store={store}>
                <Modal {...p} show={show} onHide={onHide}>
                    <Loader loaded={this.state.hydratedSession}>
                        <div id="campaign-guidelines-ctn">
                            <div className="campaign-guidelines page invite-modal-page">
                                <CampaignGuidelines
                                    {...propsToUse}
                                    application="admin_brand"
                                    doWipeCampaignInvites={() => {}}
                                    doUpdateCurrentInviteState={() => {}}
                                />
                            </div>
                        </div>
                    </Loader>
                </Modal>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./components/invite_modal.js